
export default function TrustSection() {
  return (
    <section id="trust-section" className="py-16 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            安心・信頼の実績
          </h2>
          <p className="text-lg text-gray-600">
            多くの企業様とモニター様にご信頼いただいています
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center bg-white rounded-xl p-6 shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-group-line text-3xl text-blue-600"></i>
            </div>
            <div className="text-3xl font-bold text-blue-600 mb-2">2,200名</div>
            <div className="text-sm text-gray-600">登録モニター数</div>
          </div>

          <div className="text-center bg-white rounded-xl p-6 shadow-lg">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-line text-3xl text-green-600"></i>
            </div>
            <div className="text-3xl font-bold text-green-600 mb-2">270社</div>
            <div className="text-sm text-gray-600">提携企業数</div>
          </div>

          <div className="text-center bg-white rounded-xl p-6 shadow-lg">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-line text-3xl text-orange-600"></i>
            </div>
            <div className="text-3xl font-bold text-orange-600 mb-2">7年</div>
            <div className="text-sm text-gray-600">運営実績</div>
          </div>

          <div className="text-center bg-white rounded-xl p-6 shadow-lg">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-line text-3xl text-purple-600"></i>
            </div>
            <div className="text-3xl font-bold text-purple-600 mb-2">93%</div>
            <div className="text-sm text-gray-600">
              顧客満足度<br />リピート依頼率
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg p-6 shadow-md text-center">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-shield-check-line text-2xl text-green-600"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">個人情報保護法遵守</h3>
            <p className="text-sm text-gray-600">お客様の個人情報を適切に管理・保護しています</p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-md text-center">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-file-text-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">特定商取引法表記</h3>
            <p className="text-sm text-gray-600">法令に基づく適切な運営を行っています</p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-md text-center">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-award-line text-2xl text-purple-600"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">プライバシーマーク</h3>
            <p className="text-sm text-gray-600">取得準備中（より安全な運営を目指します）</p>
          </div>
        </div>
      </div>
    </section>
  );
}
